<sb-support-text-block [title]="'Account ID' | translate" [body]="account().id" />
